export default __webpack_public_path__ + "static/media/mlc-imprejmuire.50c2f19d.jpeg";